import * as Actions from "../actions";
import * as States from "../models/state";

const INITIAL_STATE: States.ISessionState = {
  user: null
};

function sessionReducer(
  state: States.ISessionState,
  action: Actions.IAction
): States.ISessionState {
  if (state === undefined) {
    return INITIAL_STATE;
  }

  switch (action.type) {
    case Actions.Types.AuthStateChanged:
      return {
        ...state,
        user: (action as Actions.Auth.IAuthStateChanged).user
      };
    default:
      return state;
  }
}

export default sessionReducer;



// WEBPACK FOOTER //
// ./src/reducers/session.ts